/**
 * Configuración centralizada de mapas y capas de mosaicos (tiles).
 * Carto Basemaps requiere API key para eliminar la marca de agua 'API KEY REQUIRED'.
 */
export const CARTO_BASEMAP_KEY =
  process.env.REACT_APP_CARTO_API_KEY || 'cb1_2xsb_1_63b86dc2613e41d9e4f217a6';

export const MAP_TILE_URL = CARTO_BASEMAP_KEY
  ? `https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?key=${CARTO_BASEMAP_KEY}`
  : 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';

export const MAP_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>';
